<template>
  <component
    :is="tag"
    v-auto-animate
    class="inline-flex p-1 bg-gray-200 dark:bg-gray-800 rounded-md space-x-1 text-base leading-tight"
  >
    <slot />
  </component>
</template>

<script setup>
import { provide, toRefs, computed } from 'vue'
import { useProp } from '@/composables/useProp.js'
const emit = defineEmits(['update:modelValue', 'select'])

const setSegment = (name) => {
  emit('update:modelValue', name)
  emit('select', name)
}

const props = defineProps({
  modelValue: useProp(String, ''),
  tag: useProp(String, 'nav')
})

const { modelValue } = toRefs(props)

const activeSegment = computed(() => modelValue.value)

provide('selectedSegment', activeSegment)
provide('setSegment', setSegment)
provide('segmentProps', props)

</script>
